import Box from '@mui/material/Box';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export default withTheme(styled(Box)`
  position: relative;
  .name {
    @media (max-width: 768px) {
      width: 200px;
    }
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    width: 218px;
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to top, rgba(255, 255, 255, 1) 40%, rgba(255, 255, 255, 0));
  }
`);
